<template>
  <div class="gift-effects" ref="container">
  </div>
</template>

<script lang="ts" setup>
import { ref, Ref, onMounted } from 'vue';
import { UAM } from '@bilibili-live/unreal-animation-magician';
import emitter, { EB_EVENT_NAME } from '@/utils/eventbus';
import useGift, { EffectQueueEle } from './composables/use-gift';
import { IAnimation } from '@/service/broadcast/types';
import crystalConfig from '@/assets/effect/crystal/BLPC.json';
import VIDEO_CRYSTAL from '@/assets/effect/crystal/video.mp4';
import castleConfig from '@/assets/effect/castle/BLPC.json';
import VIDEO_CASTLE from '@/assets/effect/castle/video.mp4';
import carriageConfig from '@/assets/effect/carriage/BLPC.json';
import VIDEO_CARRIAGE from '@/assets/effect/carriage/video.mp4';
// import christmasConfig from '@/assets/effect/christmas/BLPC.json';
// import VIDEO_CHRISTMAS_CANDY from '@/assets/effect/christmas/candy.mp4';
// import VIDEO_CHRISTMAS_GINGERSNAP from '@/assets/effect/christmas/gingersnap.mp4';
// import VIDEO_CHRISTMAS_HAT from '@/assets/effect/christmas/hat.mp4';
// import VIDEO_CHRISTMAS_SNOWMAN from '@/assets/effect/christmas/snowman.mp4';
// import VIDEO_CHRISTMAS_TURKEY from '@/assets/effect/christmas/turkey.mp4';
// import VIDEO_CHRISTMAS_TREE from '@/assets/effect/christmas/tree.mp4';
// import VIDEO_CHRISTMAS_SUPERBOX from '@/assets/effect/christmas/super-box.mp4';


import giftService from '@/service/gift';

const giftContext = useGift();

const container: Ref<HTMLElement | null> = ref(null);

const effects = {
  ['treasure_effect_video_12']: { // crystal-ball
    config: crystalConfig,
    video: VIDEO_CRYSTAL,
  },
  ['treasure_effect_video_17']: { // castle
    config: castleConfig,
    video: VIDEO_CASTLE,
  },
  ['treasure_effect_video_24']: { // carriage
    config: carriageConfig,
    video: VIDEO_CARRIAGE,
  },
  // ['blind_box_json_candy']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_CANDY,
  // },
  // ['blind_box_json_gingersnap']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_GINGERSNAP,
  // },
  // ['blind_box_json_christmas_hat']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_HAT,
  // },
  // ['blind_box_json_snowman']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_SNOWMAN,
  // },
  // ['blind_box_json_turkey']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_TURKEY,
  // },
  // ['blind_box_json_christmas_tree']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_TREE,
  // },
  // ['blind_box_json_open_super_box']: {
  //   config: christmasConfig,
  //   video: VIDEO_CHRISTMAS_SUPERBOX,
  // },
};

let isPlaying: Ref<boolean> = ref(false);
// 连续动画索引
let animationlistIndex: number = 0;
let animationListLen: number = 0;


const preloadResource = () => {
  Object.keys(effects).forEach(async key => {
    if (requestIdleCallback) {
      requestIdleCallback(
        async () => {
          loadEffectVideo(key);
        },
        { timeout: 50000 }
      );
    } else {
      loadEffectVideo(key);
    }
  });
};

const loadEffectVideo = async (resourceName?: string): Promise<string | undefined> => {
  const effect = effects[resourceName];
  if (!effect) {
    return;
  }
  if (!effect.url) {
    const resp = await giftService.preloadAnimation(effect.video);
    effect.url = window.URL.createObjectURL(resp.data);
  }
  return effect.url || effect.video;
};

onMounted(() => {
  preloadResource();
  emitter.on(EB_EVENT_NAME.EFFECT_START, playEffect);
});

const playEffect = async (animation?: IAnimation) => {
  if (isPlaying.value) {
    return;
  }
  isPlaying.value = true;
  let targetAnimation: IAnimation | undefined = animation;
  let nextAnimation: IAnimation | undefined;

  if (!animation) {
    const effect: EffectQueueEle | undefined = giftContext.getNextEffect();
    animationListLen = effect?.animations?.length || 0;
    animationlistIndex = 0;
    targetAnimation = effect?.animations[animationlistIndex++];
    if (animationlistIndex < animationListLen) {
      nextAnimation = effect?.animations[animationlistIndex++];
    }
  }
  
  const resourceName: string | undefined = targetAnimation?.resource_name;
  const effectData = effects[resourceName];
    
  if (!effectData) {
    if (resourceName) {
      console.error(`Resource is not existed: ${resourceName}`);
    }
    isPlaying.value = false;
    return;
  }
  ;

  try {
    const config = effectData.config;
    const uam = UAM({
      container: container.value,
      src: await loadEffectVideo(resourceName) || targetAnimation?.animation_url,
      config,
      width: config.info.w,
      height: config.info.h,
      onDestroy () {
        isPlaying.value = false;
      },
    });
    uam.on('ended', () => {
      isPlaying.value = false;
      playEffect(nextAnimation);
    });
    uam.on('error', (error: any) => {
      // console.error({
      //   event: 'uam-play-error',
      //   resource_url: effectData.video,
      //   error_code: 2301,
      //   error_msg: error.message
      // });
      isPlaying.value = false;
      playEffect(nextAnimation);
    });
    // };
    // return new Promise(promiseFn);
  } catch (e: any) {
    console.error({
      event: 'uam-play-error',
      resource_url: effectData?.video,
      error_code: 1001,
      error_msg: `file not exist \n ${ e?.message }`
    });
    isPlaying.value = false;
    playEffect(nextAnimation);
  }
};

</script>

<style lang="less" scoped>
.gift-effects {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
}

</style>

<style lang="less">
.gift-effects {
  & > canvas {
    width: 100%;
  }
}
</style>